
import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
    return {
        companies: [],
        capCompanies:[],
        companyNames: [],
        companiesList: [],
        reportCompaniesList: [],
        companiesScores: [],
        companyStatus: null,
        companyAddStatus: null,
        companyDetails: null,
        errors: [],
        comapanyErrors: [],
        singleCompany: null,
        subscriptionPlans: [],
        frequencies: [],
        industries: [],
        companytypes: [],
        currencies: [],
        nacecodes: [],
        applications: [],
        companyapplications: [],
    };
  };

const companySlice = createSlice({
  name: 'company',
  initialState:initialState(),
  reducers: {
    setSingleCompany(state, action) {
      state.singleCompany = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
      state.comapanyErrors = action.payload;
    },
    setCompanyAddStatus(state, action) {
      state.companyAddStatus = action.payload;
    },
    setCompanyDetails(state, action) {
      state.companyDetails = action.payload;
    },
    setcompanyStatus(state, action) {
      state.companyStatus = action.payload;
    },
    setCompanies(state, action) {
      state.companies = action.payload;
    },
    setCapCompanies(state, action) {
      state.capCompanies = action.payload;
    },
    setCompanyNames(state, action) {
      state.companyNames = action.payload;
    },
    setCompaniesList(state, action) {
      state.companiesList = action.payload;
    },
    setReportCompaniesList(state, action) {
      state.reportCompaniesList = action.payload;
    },
    setCompaniesScores(state, action) {
      state.companiesScores = action.payload;
    },
    setSubscriptionPlans(state, action) {
      state.subscriptionPlans = action.payload;
    },
    setFrequencies(state, action) {
      state.frequencies = action.payload;
    },
    setIndustries(state, action) {
      state.industries = action.payload;
    },
    setCompanyTypes(state, action) {
      state.companytypes = action.payload;
    },
    setCurrencies(state, action) {
      state.currencies = action.payload;
    },
    setIndustryStandards(state, action) {
      state.industrystandards = action.payload;
    },
    setNaceCodes(state, action) {
      state.nacecodes = action.payload;
    },
    setApplications(state, action) {
      state.applications = action.payload;
    },
    setCompanyApplications(state, action) {
      state.companyapplications = action.payload;
    },
    
  },
});

export const {
  setSingleCompany,
  setErrors,
  setCompanyAddStatus,
  setcompanyStatus,
  setCompanies,
  setCapCompanies,
  setCompanyNames,
  setCompaniesList,
  setCompanyDetails,
  setReportCompaniesList,
  setCompaniesScores,
  setSubscriptionPlans,
  setFrequencies,
  setIndustries,
  setCompanyTypes,
  setCurrencies,
  setIndustryStandards,
  setNaceCodes,
  setApplications,
  setCompanyApplications,
  
} = companySlice.actions;

export const company = companySlice.reducer;